<app-guarda-desofizializar [listaDesoficializar]="items"></app-guarda-desofizializar>